module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "binary"
  }, [_c('div', {
    class: ['collapse-title', _vm.isPlay ? 'collapse-title-open' : 'collapse-title-default'],
    on: {
      "click": _vm.handleDisplay
    }
  }, [(_vm.isNew) ? _c('img', {
    staticClass: "tag",
    attrs: {
      "src": require("../../images/downloads/new.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "icon-display"
  }, [_c('i', {
    class: ['icon-41fenyeyou-01', 'icon-open', _vm.isPlay ? 'icon-show' : '']
  })]), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_c('div', {
    class: [_vm.item.extra_info.release ? 'release' : '']
  }, [_vm._v(_vm._s(_vm.item.name))])]), _vm._v(" "), _c('span', {
    staticClass: "update-time"
  }, [_vm._v(_vm._s(_vm.item.desc))]), _vm._v(" "), (_vm.isBinary && _vm.isPlay) ? _c('span', {
    staticClass: "update-url",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.JumpPage(_vm.item, 'update')
      }
    }
  }, [_c('i', {
    staticClass: "icon-cc-jump-link-2",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("升级指引")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    class: ['collapse-content', _vm.isPlay ? 'content-animation-open' : 'content-animation-close']
  }, [_vm._l((_vm.item.children), function(combo) {
    return _c('div', {
      key: combo.name,
      staticClass: "combo-item"
    }, [_c('div', {
      staticClass: "combo-head"
    }, [_c('span', {
      staticClass: "combo-name"
    }, [_vm._v(_vm._s(combo.name))]), _vm._v(" "), (combo.name !== '历史版本升级Patch') ? [(_vm.isBinary) ? _c('span', {
      staticClass: "combo-size"
    }, [_vm._v(_vm._s(combo.extra_info.size))]) : _vm._e(), _vm._v(" "), (_vm.isBinary) ? _c('span', {
      staticClass: "combo-md5"
    }, [_vm._v("MD5：" + _vm._s(combo.extra_info.md5))]) : _vm._e()] : _c('span', {
      staticClass: "combo-md5"
    }, [_vm._v(_vm._s(_vm.historyVersion(combo)))]), _vm._v(" "), (_vm.type === 'binary') ? [(combo.name !== '历史版本升级Patch') ? [(combo.extra_info.open && combo.extra_info.open !== '') ? _c('span', {
      staticClass: "combo-open",
      on: {
        "click": function($event) {
          return _vm.JumpPage(combo, 'open')
        }
      }
    }, [_c('i', {
      staticClass: "icon-github-logo",
      staticStyle: {
        "font-size": "16px",
        "margin-right": "5px"
      }
    }), _vm._v("开源地址")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "combo-download",
      on: {
        "click": function($event) {
          return _vm.JumpPage(combo, 'download')
        }
      }
    }, [_c('i', {
      staticClass: "icon-xiazai",
      staticStyle: {
        "font-size": "14px"
      }
    }), _vm._v("\n                                立即下载\n                            ")])] : [_c('span', {
      staticClass: "combo-download",
      on: {
        "click": function($event) {
          return _vm.JumpPage(combo, 'download')
        }
      }
    }, [_c('i', {
      staticClass: "icon-xiazai",
      staticStyle: {
        "font-size": "14px"
      }
    }), _vm._v("\n                                立即下载\n                            ")]), _vm._v(" "), _c('span', {
      staticClass: "combo-update",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.JumpPage(combo, 'update')
        }
      }
    }, [_c('i', {
      staticClass: "icon-cc-jump-link-2",
      staticStyle: {
        "font-size": "14px",
        "margin-right": "4px"
      }
    }), _vm._v("升级指引")])]] : _c('span', {
      staticClass: "combo-deploy",
      on: {
        "click": function($event) {
          return _vm.JumpPage(combo, 'deploy')
        }
      }
    }, [_vm._v("前往部署"), _c('i', {
      staticClass: "icon-cc-jump-link-2",
      staticStyle: {
        "font-size": "14px"
      }
    })])], 2), _vm._v(" "), _c('div', {
      staticClass: "combo-content"
    }, _vm._l((combo.children), function(product, index) {
      return _c('ul', {
        key: index,
        staticClass: "product",
        style: ({
          'width': product.name === '亮点功能' ? 'calc(100% - 520px)' : '260px'
        })
      }, [(product.name === '套餐内容') ? [_c('li', {
        staticStyle: {
          "font-weight": "Bold",
          "color": "#313238",
          "margin-bottom": "9px"
        }
      }, [_vm._v(_vm._s(product.name))]), _vm._v(" "), _vm._l((product.children), function(product1) {
        return _c('li', {
          key: product1.name
        }, [(product1.name === '更多详细日志') ? [_c('span', {
          staticClass: "more-log",
          on: {
            "click": function($event) {
              return _vm.JumpPage(product1, 'more')
            }
          }
        }, [_c('i', {
          staticClass: "icon-cc-jump-link-2",
          staticStyle: {
            "font-size": "14px",
            "margin-right": "8px"
          }
        }), _vm._v(_vm._s(product1.name))])] : [_c('img', {
          staticStyle: {
            "width": "16px",
            "height": "16px",
            "margin-right": "8px"
          },
          attrs: {
            "src": product1.resource,
            "alt": ""
          }
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(product1.name))])]], 2)
      })] : _vm._e(), _vm._v(" "), (product.name === '亮点功能') ? [_c('li', {
        staticStyle: {
          "font-weight": "Bold",
          "color": "#313238",
          "margin-bottom": "9px"
        }
      }, [_vm._v(_vm._s(product.name))]), _vm._v(" "), _vm._l((product.extra_info.update_list), function(product1) {
        return _c('li', {
          key: product1
        }, [_c('span', [_vm._v(_vm._s(product1))])])
      })] : _vm._e()], 2)
    }), 0)])
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-69e717be!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/downloads/binary.vue
// module id = kkhX
// module chunks = 15